import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import ChipsDropDown from '../components/ChipsDropDown';
import { ProductsContext } from '../../ProductsContext';
import ChipsDropDownWithComparison from '../components/ChipsDropDownWithComparison';
import { BlockRightArrowIcon } from 'assests/GmsIcons';

type TReviewProps = {
    selectedProducts: TOption[],
    setSelectedProducts: Dispatch<SetStateAction<TOption[]>>
    payload: TRecategorizePayload
    finalPayload: TRecategorizePayload
    setPayload: Dispatch<SetStateAction<TRecategorizePayload>>
    setFinalPayload: Dispatch<SetStateAction<TRecategorizePayload>>
}

const Review = ({ selectedProducts, setSelectedProducts, payload, setPayload, setFinalPayload }: TReviewProps) => {
    const [commonAttributes, setCommonAttributes] = useState<TOption[]>([{ id: "string", name: "string" }])
    const [transferAttributes, setTransferAttributes] = useState<TOption[]>([{ id: "string", name: "string" }])
    const [mapAttributes, setMapAttributes] = useState<{ sourceName: string, targetName: string }[]>([{ sourceName: "string", targetName: "string" }])
    const reviewObj = [
        {
            header: "Move Products",
            options: selectedProducts,
            setOptions: setSelectedProducts
        },
        {
            header: "Common Attributes",
            options: commonAttributes,
            setOptions: setCommonAttributes
        },
        {
            header: "Transfer Attributes",
            options: transferAttributes,
            setOptions: setTransferAttributes
        }
    ]

    const extractAndSetCommonAttributes = () => {
        const final_common_attr_list: CommonAttributePayload[] = []
        const commonAttributesArray = payload?.common_attr_list?.filter(attribute => attribute?.checked)?.map(x => {
            return {
                id: x?.attribute_id,
                name: x?.attribute_name
            }
        })
        setCommonAttributes(commonAttributesArray)
        setFinalPayload({ ...payload, common_attr_list: final_common_attr_list })
    }


    const extractAndSetTranferAndMapAttributes = () => {
        const transferAttributesArray: TOption[] = []
        const mapAttributesArray: { sourceName: string, targetName: string }[] = []
        const final_unique_attr_source_list: UniqueAttributePayload[] = []
        payload?.unique_attr_source_list?.forEach(attrObj => {
            if (attrObj?.checked) {
                final_unique_attr_source_list.push(attrObj)
                if (attrObj?.action === 'transfer')
                    transferAttributesArray?.push({ id: attrObj?.attribute_id as string, name: attrObj?.attribute_name as string })
                else if (attrObj?.action === 'map')
                    mapAttributesArray?.push({ sourceName: attrObj?.attribute_name as string, targetName: attrObj?.target_attribute_name as string })
            }
        })
        setTransferAttributes(transferAttributesArray)
        setMapAttributes(mapAttributesArray)
        setFinalPayload({ ...payload, unique_attr_source_list: final_unique_attr_source_list })
    }

    useEffect(() => {
        extractAndSetCommonAttributes()
    }, [payload?.common_attr_list])

    useEffect(() => {
        extractAndSetTranferAndMapAttributes()
    }, [payload?.unique_attr_source_list])


    return (
        <div className='tw-justify-center tw-items-center'>
            <div className="tw-w-[350px] tw-text-[#172b4d] tw-text-sm tw-font-semibold tw-mt-4">Review the changes</div>
            <div className='tw-flex tw-justify-between tw-mt-4'>
                <div className='tw-w-[45%]'>
                    <div className="tw-text-[#6d788c] tw-text-sm tw-font-medium tw-mb-2">(From) Source </div>
                    <div className=" tw-w-full tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-[#d1d1d6] tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                        <div className="tw-grow tw-shrink tw-basis-0 tw-text-[#172b4d] tw-text-sm tw-font-normal">{payload?.source_category_name}</div>
                    </div>
                </div>
                <div className='tw-mt-10'>
                    <BlockRightArrowIcon />
                </div>
                <div className='tw-w-[45%]'>
                    <div className="tw-text-[#6d788c] tw-text-sm tw-font-medium tw-mb-2">(To) Target </div>
                    <div className="tw-w-full tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-[#d1d1d6] tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                        <div className="tw-grow tw-shrink tw-basis-0 tw-text-[#172b4d] tw-text-sm tw-font-normal">{payload?.target_category_name}</div>
                    </div>
                </div>
            </div>
            {reviewObj?.map(x =>
                <div className='tw-w-[700px] tw-mt-4 tw-mb-4'>
                    {
                        <ChipsDropDown
                            header={x?.header}
                            options={x?.options}
                            setOptions={x?.setOptions}
                            remove={false}
                        />
                    }
                </div>)}
            <div className='tw-w-[700px] tw-mt-4 tw-mb-4'>
                {
                    <ChipsDropDownWithComparison
                        header={"Map Attributes"}
                        options={mapAttributes}
                    />
                }
            </div>

        </div>

    );
}

export default Review;